import * as React from 'react';
import { compose } from '@grandvisionhq/utils';
import '@swc/helpers';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import '@grandvisionhq/layout';
import '../Accordion/Accordion.js';
import '../Article/Article.js';
import '../ArticleCollection/ArticleCollection.js';
import '../Banner/Banner.js';
import '../BannerCollection/BannerCollection.js';
import '../BlogCollection/BlogCollection.js';
import '../BlogOverview/BlogOverview.js';
import '../BrandCollection/BrandCollection.js';
import '../BrandList/BrandList.js';
import '../Carousel/Carousel.js';
import '../CountdownTimer/CountdownTimerDocument.js';
import '../Iframe/Iframe.js';
import '../LinkList/LinkList.js';
import '../RecommendedProducts/RecommendedProducts.js';
import '../RichText/RichTextDocument.js';
import '../Video/Video.js';
import '../Widget/Widget.js';
import '@grandvisionhq/elements';
import '../CountdownTimer/CountdownTimer.js';
import '../Document/Document.js';
import '../Faq/Faq.js';
import '../GroupedCards/GroupedCards.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/auth';
import '@grandvisionhq/frk-routing';
import '../Heading/Heading.js';
import '../IconList/IconList.js';
import '../Newsletter/Newsletter.js';
import '../NewsletterBanner/NewsletterBanner.js';
import '../TryInStoreBanner/TryInStoreBanner.js';
import '../NotificationBar/NotificationBar.js';
import '../PolicyBar/PolicyBar.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/products';
import '../Breadcrumbs/Breadcrumbs.js';
import '../ProductCatalog/ProductCatalog.js';
import '../Promotion/Promotion.js';
import '../RecentlyViewedProducts/RecentlyViewedProducts.js';
import '../RichText/RichText.js';
import '../WidgetTrustedShop/WidgetTrustedShop.js';
import '../Whitespace/Whitespace.js';
import '../SpotlightedStores/SpotlightedStores.js';
import '../FixedCta/FixedCta.js';
import '../Button/Button.js';
import '../GlobalContactForm/GlobalContactForm.js';
import 'classnames';
import '../RowComponent/RowText/RowText.js';
import '../RowComponent/RowProductListBySku/RowProductListBySku.js';
import CmsContentLayout from '../../layouts/Content.js';
import CmsBlogLayout from '../../layouts/Blog.js';

const isBlogArticle = (content)=>content.type === 'blogArticle'
;
const CmsXPagesContent = ({ content , pageName  })=>{
    let name = pageName;
    if (content.type === 'brand') {
        name = 'brand-detail';
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isBlogArticle(content) ? /*#__PURE__*/ React.createElement(CmsBlogLayout, {
        content: content
    }) : /*#__PURE__*/ React.createElement(CmsContentLayout, {
        content: content,
        pageName: name,
        hasBreadcrumbs: false
    }));
};
var CmsXPagesContent$1 = compose(withHidableContent, withBloomreachData, withEditableContent)(CmsXPagesContent);

export { CmsXPagesContent, CmsXPagesContent$1 as default };
//# sourceMappingURL=XPagesContent.js.map
